
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customformulariovpyyj_676adc589ccea34376cf965e } from '../../api/formulariocontactanosegqvw.api'

import './contactanosigzsv.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pcontactanosigzsv = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id676adaff1de4874021c2184e" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <img
        className=""
        id="i7sf2j"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5mu70g5.png"
        alt="undefined"
      />
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/servicios"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>SERVICIOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/blog"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>ARTICULOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ig1at"
        href="/contactanos"
        type="button"
      >
        
    <div id="isq53" className="">
    <>CONTÁCTANOS</>
    </div>
    
      </a>
      
      </div>
      
      <div id="ibbry6" className="">
      
      </div>
      
      <div id="iacot" className="">
      
      <span className="material-icons " id="indcti">
        
      <span className="material-icons " id="izk84l">
        
      </span>
      
      </span>
      
        <a
          target="_blank"
          className=""
          id="isdo4d"
          href=""
        >
          
      <span className="material-icons " id="i3c93a">
        <>call</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="igbhjj"
          href=""
        >
          
      <span className="material-icons " id="iu387l">
        <>mail</>
      </span>
      
        </a>
        
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>INICIO</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/servicios"
        type=""
      >
        <>SERVICIOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/articulos"
        type=""
      >
        <>ARTICULOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>CONTÁCTANOS</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i61o1s" className="">
      
      <div id="ihk8" className="">
      
      </div>
      
      <div id="i0i0wb" className="">
      
      <div
        id="ihl1ke"
        className=""
        data-aos="fade-left"
        data-aos-duration="2000"
      >
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iibcbd">
        <>Claudia Tábora</>
      </span>
      
      </div>
      
      <div id="i1oihf" className="">
      
      </div>
      
      <div className="" id="ibk4py">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iud70f">
        <>Terapeuta Energetica</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6xx" className="">
      
      <div id="i0tfl" className="">
      
      <div id="ir45r1" className="">
      
      <div id="iv4qtt" className="">
      
      <div className="" id="i55lui">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="id0hfs">
        <>Nos encantaría saber de usted</>
      </span>
      
      </div>
      
      <div className="" id="iwd268">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="indrga">
        <>Descubre cómo las terapias energéticas pueden transformar tu vida. Agenda tu cita y comienza tu camino hacia el bienestar integral.</>
      </span>
      
      </div>
      
      </div>
      
      <div id="i8blk9" className="">
      
      <div id="i5fv0u" className="">
      
      <img
        className=""
        id="izzkyi"
        src="https://assetsprojects.s3.amazonaws.com/404no3im52o2sos.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iuqw9g" className="">
      
      <div className="" id="icl0zh">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it9ql6">
        <>Numero de contacto</>
      </span>
      
      </div>
      
      <div className="" id="ik9g44">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ici8uz">
        <>+504 33820107</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i2djmt" className="">
      
      </div>
      
      <div id="ipuo4i" className="">
      
      <div id="i77gav" className="">
      
      <img
        className=""
        id="iydfth"
        src="https://assetsprojects.s3.amazonaws.com/404no3im52o2tfx.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="idkj8h" className="">
      
      <div className="" id="ielgja">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ih8njf">
        <>Horario de atencion </>
      </span>
      
      </div>
      
      <div className="" id="imo7xy">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iygzi4">
        <>Lunes - Sabado, 07.00-16.00</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="it99xj" className="">
      
      </div>
      
      <div id="ing9jk" className="">
      
      <div id="irofib" className="">
      
      <img
        className=""
        id="i8fdug"
        src="https://assetsprojects.s3.amazonaws.com/404no3im52o2uag.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i73fs1" className="">
      
      <div className="" id="il8p7z">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ihxt7d">
        <>Dirección</>
      </span>
      
      </div>
      
      <div className="" id="is9jhy">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iy35qg">
        <>Choloma, Cortes</>
      <br className="" id="" />
      <>Res. Bello Horizonte, Segunda etapa</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i1xrzo" className="">
      
        <div className="" id="iuvubv">
          
      <form
        id="i7wchf"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await customformulariovpyyj_676adc589ccea34376cf965e({
						token: 'aasdas',
				nombreeu35e: e.target.nombreeu35e.value,
						correof58ql: e.target.correof58ql.value,
						mensajevc3b4: e.target.mensajevc3b4.value,
					});
				} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="imkwmv" className="">
      
      <label id="ircjyz" className="">
      <>Nombre</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="nombreeu35e"
        type="text"
        placeholder="Escriba su Nombre"
        className=""
        id="iiw1k8"
      />
      
      </div>
      
      <div id="iiq43b" className="">
      
      <label id="iov0l7" className="">
      <>Su Correo electronico</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="correof58ql"
        type="text"
        placeholder="Escriba su correo electronico"
        className=""
        id="i4ipkk"
      />
      
      </div>
      
      <div id="ie89cj" className="">
      
      <label id="i3kg7z" className="">
      <>Su Mensaje</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="mensajevc3b4"
        type="text"
        placeholder="Escriba un mensaje"
        className=""
        id="ipvtfv"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="ivd6dx"
        className=""
        
      >
      
      <div id="ieidr2" className="">
      <>ENVIAR</>
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9f89n">
        <>Choloma, Cortes</>
      <br className="" id="" />
      <>Res. Bello Horizonte, Segunda etapa</>
      </span>
      
      </div>
      
      <div id="i3kbn4" className="">
      
        <a
          target="_blank"
          className=""
          id="ixsthl"
          href="#"
        >
          
      <img
        className=""
        id="iwpiyw"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jbbv.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ikcig4"
          href="#"
        >
          
      <img
        className=""
        id="iv6mle"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jd5s.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="itq03p"
          href="#"
        >
          
      <img
        className=""
        id="isa627"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jfas.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ig3kxb"
          href="#"
        >
          
      <img
        className=""
        id="iqlafz"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4x6jgsb.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <img
        className=""
        id="iqtzsi"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim5mu722a.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div id="i2vw8i" className="">
      
      </div>
      
      <div id="iabdji" className="">
      
      <div id="izci0t" className="">
      
      <div className="" id="izq2dp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iubk6b">
        <>Copyrigt © 2024 </>
      </span>
      
      </div>
      
      <div className="" id="i4zwph">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="ix41ho">
        <>Terapias Energéticas</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ip8opa" className="">
      
      <div className="" id="in8zl9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iytx9d">
        <>Términos y condiciones</>
      </span>
      
      </div>
      
      <div className="" id="ivyeul">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i5zx35">
        <>Políticas de privacidad</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcontactanosigzsv);
  